import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface UpdatePartNumberStateType {
    readonly isLoading: boolean;
    readonly currentID: string;
    readonly errorMessage: string;
}

export type UpdatePartNumberState = Readonly<UpdatePartNumberStateType>;

export const updatePartNumberState: UpdatePartNumberState = {
    isLoading: false,
    currentID: "",
    errorMessage: "",
};

export const customUpdatePartNumberReducer = createTypedReducer(updatePartNumberState, {
    "Custom/UpdatePartNumberState/Loading": (
        draft: Draft<UpdatePartNumberState>,
        { isLoading }: { isLoading: boolean },
    ) => ({
        ...draft,
        isLoading,
    }),

    "Custom/UpdatePartNumberState/CompletedLoadUpdatePartNumber": (
        draft: Draft<UpdatePartNumberState>,
        { currentID }: { currentID: string },
    ) => ({
        ...draft,
        currentID,
    }),

    "Custom/UpdatePartNumberState/FailedToLoadUpdatePartNumber": (
        draft: Draft<UpdatePartNumberState>,
        { message }: { message: string },
    ) => ({
        ...draft,
        isLoading: false,
        errorMessage: message,
    }),
     // New action to reset the state
     "Custom/UpdatePartNumberState/ResetUpdatePartNumberState": (
        draft: Draft<UpdatePartNumberState>
    ) => ({
        ...updatePartNumberState, // Resets the state to initial values
    }),
});
